// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__19Su4","card":"Cards_card__1onht","infected":"Cards_infected__5oE3Z","recovered":"Cards_recovered__3l_Ac","deaths":"Cards_deaths__jFJ3s"};